export const SET_CUSTOMER_BUNDLES = 'SET_CUSTOMER_BUNDLES'
export const RESET_CUSTOMER_BUNDLES = 'RESET_CUSTOMER_BUNDLES'
export const SET_CUSTOMER_ALL_BUNDLES = 'SET_CUSTOMER_ALL_BUNDLES'
export const RESET_CUSTOMER_ALL_BUNDLES = 'RESET_CUSTOMER_ALL_BUNDLES'
export const RESET_CUSTOMER_ORIGINATING_BUNDLES = 'RESET_CUSTOMER_ORIGINATING_BUNDLES'
export const SET_CUSTOMER_ORIGINATING_BUNDLES = 'SET_CUSTOMER_ORIGINATING_BUNDLES'